import { render, staticRenderFns } from "./appPage.vue?vue&type=template&id=8dfc81aa&scoped=true"
import script from "./appPage.vue?vue&type=script&lang=js"
export * from "./appPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfc81aa",
  null
  
)

export default component.exports